<div class="footer-nav" #navRoot>
	<div class="footer-nav-left"><template #leftButtons></template></div>
	<div class="footer-nav-center" [ngClass]="!renderCenter ? 'dont-display' : null"><template #centerButtons></template></div>
	<div class="footer-nav-right"><template #rightButtons></template></div>
</div>
